import React, { useEffect, useState } from "react";
import Select from "react-select";

export type ImageOption = {
  value: string;
  label: string;
  imageUrl?: string;
};

export interface ImageSelectProps {
  options: ImageOption[];
  defaultValue?: ImageOption;
  className?: string;
  styles?: any;
  onChange?: (selected: ImageOption | null) => void;
  isDisabled?: boolean;
  placeHolder?: string;
  imageSize?: number;
}

const ImageSelect: React.FC<ImageSelectProps> = ({
  options,
  defaultValue,
  className,
  onChange,
  isDisabled,
  placeHolder,
  imageSize = 24,
}) => {
  const [selectedOption, setSelectedOption] = useState<ImageOption | undefined>(
    defaultValue
  );

  useEffect(() => {
    setSelectedOption(defaultValue || undefined);
  }, [defaultValue]);

  const formatOptionLabel = (
    option: ImageOption,
    { context }: { context: string }
  ) => (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {option.imageUrl ? (
        <img
          src={option.imageUrl}
          alt={option.label}
          style={{
            width: `${imageSize}px`,
            height: `${imageSize}px`,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      ) : (
        <div
          style={{
            width: `${imageSize}px`,
            height: `${imageSize}px`,
            borderRadius: "50%",
            backgroundColor: "#f0f0f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: `${imageSize * 0.5}px`,
            color: "#555",
          }}
        >
          {option.label?.charAt(0).toUpperCase() || "?"}
        </div>
      )}
      <span>{option.label}</span>
    </div>
  );

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      backgroundColor: isDisabled ? "#F8F9FA" : "white",
      color: "#6B7280",
      opacity: isDisabled ? 0.7 : 1,
      cursor: isDisabled ? "not-allowed" : "pointer",
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: "white",
      zIndex: 9999,
    }),
    option: (provided: any, state: { isSelected: boolean }) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : "white",
      color: state.isSelected ? "white" : "black",
      "&:hover": {
        backgroundColor: state.isSelected ? "#007bff" : "#f0f0f0",
      },
    }),
    singleValue: (provided: any) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      gap: "8px",
    }),
  };

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      styles={customStyles}
      options={options}
      value={selectedOption}
      onChange={onChange}
      placeholder={placeHolder || "Select"}
      isDisabled={isDisabled}
      formatOptionLabel={formatOptionLabel}
    />
  );
};

export default ImageSelect;
